import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import useTranslation from "../../hooks/traslation";
import moment from "moment";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { showError } from "../../constants/toasts";
import { useLazyGetCategoryByIdQuery } from "../../services/category";
import CategoryViewModal from "../../Modals/categoryViewModal";
import { getFromStorage } from "../../helpers/storage";
import { STORAGE_KEYS } from "../../constants/storageKeys";

interface Employer {
  _id: string;
  firstName: string;
  lastName: string;
  image: string;
  email: string;
}

interface Freelancer {
  _id: string;
  firstName: string;
  lastName: string;
  image: string;
  email: string;
}

interface PaymentRow {
  _id: string;
  total: number;
  createdAt: string;
  referenceId?: string;
  employer: Employer;
  freelancer: Freelancer;
  category: {
    _id: string;
    name: string;
    image: string;
  };
  subCategory: {
    _id: string;
    name: string;
  };
}

interface PaymentsListProps {
  rows: PaymentRow[];
  isLoading: boolean;
  count: number;
  page: number;
  onPageChange: (event: any, newPage: number) => void;
}

const PaymentsList = ({
  rows,
  isLoading,
  count,
  page,
  onPageChange,
}: PaymentsListProps) => {
  const navigate = useNavigate();
  const [isLoadingM, setIsLoadingM] = useState(false);
  const translate = useTranslation();
  const [selectedId, setSelectedId] = useState("");
  const [data, setData] = useState<any>();
  const [open, setOpen] = useState(false);
  const [getCatogeryById] = useLazyGetCategoryByIdQuery();
  // const getLang = getFromStorage(STORAGE_KEYS.language);

  const getDataById = async () => {
    setIsLoadingM(true);
    try {
      const response = await getCatogeryById({ id: selectedId }).unwrap();
      if (response?.statusCode === 200) {
        setData({
          ...response?.data,
          subCategory: rows.find((row) => row.category._id === selectedId)
            ?.subCategory,
        });
      } else {
        setIsLoadingM(false);
      }
    } catch (error: any) {
      setIsLoadingM(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (selectedId) {
      getDataById();
    }
  }, [selectedId]);

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 180,
      field: "issue",
      headerName: "Catogery Details",
      editable: false,
      sortable: false,
      renderCell: (row) => {
        return (
          <div
            className="user_block"
            onClick={() => {
              setOpen(true);
              setSelectedId(row?.row?.category?._id);
            }}
            style={{ width: '100%', wordBreak: 'break-word' }}
          >
            <figure className="no_radius">
              <img
                src={
                  row?.row?.category?.image || "/static/images/placeholder.png"
                }
                alt={row?.row?.category?.name || ""}
              />
            </figure>
            <p style={{ margin: 0, whiteSpace: 'normal' }}>
              <b>{row?.row?.category?.name || ""}</b>
              <span>{row?.row?.subCategory?.name || ""}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 220,
      field: "customer",
      headerName: translate?.main?.employerDetails,
      editable: false,
      sortable: false,
      renderCell: (row) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(`/manage-employers/detail/${row?.row?.employer._id}`)
            }
          >
            <figure>
              <img
                src={
                  row?.row?.employer.image ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{`${row?.row?.employer.firstName} ${row?.row?.employer.lastName}`}</b>
              <span>{row?.row?.employer.email}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 220,
      field: "maintenance",
      headerName: translate?.main?.freelancerDetail,
      editable: false,
      sortable: false,
      renderCell: (row) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(`/manage-freelancer/detail/${row?.row?.freelancer._id}`)
            }
          >
            <figure className="no_radius">
              <img
                src={
                  row?.row?.freelancer.image || "/static/images/placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{`${row?.row?.freelancer.firstName} ${row?.row?.freelancer.lastName}`}</b>
              <span>{row?.row?.freelancer.email}</span>
            </p>
          </div>
        );
      },
    },
    {
      minWidth: 150,
      field: "offered",
      headerName: translate?.main?.taskPrice,
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (row) => {
        return (
          <p className="c_primary">
            <strong>{row?.row?.total} BHD</strong>
          </p>
        );
      },
    },
    {
      minWidth: 200,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: (row) => {
        return moment(row?.row?.createdAt).format("DD MMMM YYYY, hh:mm A");
      },
    },
    {
      minWidth: 180,
      field: "transactionId",
      headerName: "Transaction ID",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return <span>{row?.referenceId || "-"}</span>;
      },
    },
    {
      minWidth: 130,
      field: "status",
      headerName: translate?.main?.status,
      editable: false,
      sortable: false,
      renderCell: () => {
        return <span className="btn_text c_success">Paid</span>;
      },
    },
  ];
  let hidden = ["fullName"];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
          loading={isLoading}
          count={count}
          page={page}
          onPageChange={onPageChange}
        />
      </div>

      <CategoryViewModal
        open={open}
        selectedId={selectedId}
        onClose={() => setOpen(false)}
        setSelectedId={setSelectedId}
        setOpen={setOpen}
        data={data}
      />
    </>
  );
};

export default PaymentsList;
